import api from './axios'

export const getZonesList = async projectId => {
        const response = await api.get(`/zones/list/${projectId}`)
        return response.data
}

export const getZone = async zoneId => {
        const response = await api.get(`/zones/${zoneId}`)
        return response.data
}

export const createZone = async zoneData => {
        const response = await api.post('/zones', zoneData)
        return response.data
}

export const updateZone = async (zoneId, zoneData) => {
        const response = await api.put(`/zones/${zoneId}`, zoneData)
        return response.data
}

export const activateZone = async zoneId => {
        const response = await api.put(`/zones/${zoneId}/activate`)
        return response.data
}

export const deleteZone = async zoneId => {
        const response = await api.delete(`/zones/${zoneId}`)
        return response.data
}
